<template>
  <main>
    <PageIntro v-if="appLogin === false"
      :heading="'Complete your registration'"
      :body="'<p>In order to complete your registration you must confirm the following details. </p>'" />
    <PageIntro v-else
      :heading="'Complete your registration'"
      :body="''" />
    <RegistrationAdditional />
    <FooterShout v-if="appLogin === false" :type="'profile'"/>
  </main>
</template>

<script>
  import RegistrationAdditional from '@/components/RegistrationAdditional'
  import PageIntro from '@/components/PageIntro'
  import FooterShout from '@/components/FooterShout'

  export default {
    components: {
      RegistrationAdditional,
      PageIntro,
      FooterShout
    },
    data() {
      return {
        appLogin: false
      }
    },
    mounted () {
      // if they are coming from the app specific login URL adapt the page accordingly
      if(this.$router.currentRoute.name === 'app-register'){
        this.appLogin = true
      }
    },
  }
</script>
